import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { ApiError } from "./api/client";
import { ToastProvider } from "./components/Toast";
import "./styles/base.css";

const queries = new QueryClient({
  defaultOptions: {
    queries: {
      // A signed-out session is not a transient failure, and retrying it three
      // times only delays showing the sign-in page. Anything else gets two
      // goes, because a dropped request on a train is worth retrying.
      retry: (attempt, error) =>
        !(error instanceof ApiError && (error.isUnauthenticated || error.status === 403)) &&
        attempt < 2,
      refetchOnWindowFocus: true,
      staleTime: 10_000,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queries}>
      <BrowserRouter>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
